{
  "availableBalance": "ยอดคงเหลือที่ใช้ได้",
  "lockedQuantity": "จำนวนที่ล็อก",
  "deposit": "รับเหรียญ",
  "assetDetails": "รายละเอียดสินทรัพย์",
  "filter": {
    "all": "ทั้งหมด",
    "deposit": "รับเหรียญ",
    "swap": "แลกเปลี่ยน",
    "payment": "ชำระเงิน",
    "buyCoin": "ซื้อเหรียญ",
    "sellCoin": "ขายเหรียญ",
    "return": "รางวัล",
    "others": "อื่น ๆ"
  }
}
